// app/javascript/matches/stepper.js
(() => {
  // Turbo遷移でも二重にバインドされないようにガード
  if (window.__STEPperInited) return;
  window.__STEPperInited = true;

  // クリックをイベント委譲で拾う（長押しは実装しない）
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".stepper-btn");
    if (!btn) return;

    const wrap  = btn.closest(".stepper");
    const input = wrap?.querySelector(".stepper-input");
    if (!input) return;

    const step = parseInt(input.step || "1", 10);
    const min  = input.min !== "" ? parseInt(input.min, 10) : -Infinity;
    const max  = input.max !== "" ? parseInt(input.max, 10) :  Infinity;

    let val = parseInt(input.value, 10);
    if (Number.isNaN(val)) val = 0;

    val += (btn.dataset.action === "incr" ? step : -step);
    if (val < min) val = min;
    if (val > max) val = max;

    input.value = val;

    // Rails側に変更を通知（バリデーション/表示更新のため）
    input.dispatchEvent(new Event("input",  { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
})();
